/*const API_URL = 'http://localhost:8080/api/flows';

export async function createFlow(flow) {
  try {
    const res = await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(flow),
    });
    if (!res.ok) throw new Error('Error creando flujo');
    return await res.json();
  } catch (error) {
    console.error('createFlow error:', error);
    throw error;
  }
}

export async function getFlows() {
  try {
    const res = await fetch(API_URL);
    if (!res.ok) throw new Error('Error obteniendo flujos');
    return await res.json();
  } catch (error) {
    console.error('getFlows error:', error);
    return [];
  }
}

export async function updateFlow(id, flow) {
  try {
    const res = await fetch(`${API_URL}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(flow),
    });
    if (!res.ok) throw new Error('Error actualizando flujo');
    return await res.json();
  } catch (error) {
    console.error('updateFlow error:', error);
    throw error;
  }
}

export async function deleteFlow(id) {
  try {
    const res = await fetch(`${API_URL}/${id}`, {
      method: 'DELETE',
    });
    if (!res.ok) throw new Error('Error eliminando flujo');
  } catch (error) {
    console.error('deleteFlow error:', error);
    throw error;
  }
}
*/
// flowService.js (versión mock sin fetch real)

const API_URL = 'http://localhost:8080/api/flows';

export async function getFlows() {
  try {
    const response = await fetch(API_URL);
    if (!response.ok) throw new Error('Error al obtener flujos');
    return await response.json();
  } catch (error) {
    console.error('getFlows error:', error);
    throw error;
  }
}

export async function getFlowById(id) {
  try {
    const response = await fetch(`${API_URL}/${id}`);
    if (!response.ok) throw new Error('Error al obtener el flujo');
    return await response.json();
  } catch (error) {
    console.error('getFlowById error:', error);
    throw error;
  }
}

export async function saveFlow(flow) {
  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(flow),
    });
    if (!response.ok) throw new Error('Error al guardar el flujo');
    return await response.json();
  } catch (error) {
    console.error('saveFlow error:', error);
    throw error;
  }
}

export async function deleteFlow(flowId) {
  try {
    const response = await fetch(`${API_URL}/${flowId}`, {
      method: 'DELETE'
    });
    if (!response.ok) throw new Error('Error al eliminar el flujo');
    return true;
  } catch (error) {
    console.error('deleteFlow error:', error);
    throw error;
  }
}
